/**
 * The avatar-menu label for the analytics / earnings entry.
 *
 * The creator EARNINGS (referral) programme is SUSPENDED for NEW sign-ups
 * (Gordon, 2026-07-24: "The Earnings Portal popup should not be showing up
 * for now - we suspended the earnings program"), but Gordon 2026-09-24
 * clarified the suspension is a promo-gate, not a member-access gate:
 * "Earnings Program unhidden for current Earnings Program members." An
 * ALREADY-enrolled member (isInReferralProgram true) keeps the "Earnings
 * Portal" name for this entry regardless of `suspended` — matching the same
 * enrollment carve-out `canAccessReferralDashboard`
 * (constants/referralAccess.js) already grants the /referrals tab map and
 * the legacy Navbar's "Referrals" entry; this was the one surface that still
 * checked `suspended` alone and missed it. Deliberately NOT
 * `canAccessReferralDashboard` itself: that helper answers "can this viewer
 * reach the dashboard" (true for EVERYONE once the programme resumes, member
 * or not), whereas this label must keep naming it "Analytics" for a
 * non-member even after resume — they are not a programme member, so calling
 * their entry "Earnings Portal" would be false marketing. `suspended` is kept
 * as a parameter only so callers don't have to change; it is intentionally
 * unused — enrollment alone decides the label.
 *
 * Extracted from the JSX so the rule can be asserted directly. Callers may
 * still pass `suspended` (existing call sites do); it is accepted and
 * ignored so no call site needs to change.
 */
export const EARNINGS_LABEL = "Earnings Portal";
export const ANALYTICS_LABEL = "Analytics";

export function earningsMenuLabel({ isInReferralProgram }) {
  return isInReferralProgram ? EARNINGS_LABEL : ANALYTICS_LABEL;
}

export default earningsMenuLabel;
